// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './attribute-status.properties';

const ATTRIBUTE_STATUS_VALUES = [
  'OK',
  'MISSING',
  'REFERENCE_MISSING',
  'WRONG_CATEGORY',
  'WRONG_TYPE',
  'WRONG_OBJECTTYPE_CATEGORY',
  'WRONG_DATASOURCE_CAPABILITIES',
  'MAX_ATTRIBUTE_COUNT',
  'MAX_LEVEL_COUNT',
  'GEOMETRY_NOT_ALLOWED',
  'GEOMETRY_ID_RELATION_MISSING',
  'MULTIPLE_HIERARCHY',
  'UNREACHABLE',
  'UNREACHABLE_IN_COMBINED_OBJECTTYPE',
  'CUSTOM_AGGREGATION_FUNCTION_ATTRIBUTE_NOT_ALLOWED',
  'CARDINALITY_FROM_GEOMETRY_NOT_ONE',
  'CARDINALITY_FROM_CATEGORY_NOT_ONE',
  'INCOMPATIBLE_AGGREGATION_FUNCTION',
  'INCOMPATIBLE_AGGREGATIONS_FOR_FRACTION_CALCULATION',
  'INCOMPATIBLE_FRACTION_CALCULATION_FOR_TABLE_MODE',
] as const;

/** @see net/disy/cadenza/repository/api/objecttype/AttributeStatus.java */
export type AttributeStatus = (typeof ATTRIBUTE_STATUS_VALUES)[number];

export const AttributeStatus = {
  values: ATTRIBUTE_STATUS_VALUES as readonly AttributeStatus[],
  i18n: (value: AttributeStatus) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>

import i18nMessages from './attribute-status-messages.properties';

export function attributeStatusMessage (value: AttributeStatus) {
  return i18nMessages(`<${value}>.message`);
}
